import {
  createProgressiveRequestHandler,
  createRequestHandler,
} from "../utils/requestHandlers";

import { cfAPI } from "../api";
import { createFormData } from "../utils/onCreateFormData";
import { createProgressHandler } from "../utils/createProgressHandler"; // Assuming this utility exists

// Import reusable handlers

// Action Types
const AWARD_REQUEST = "AWARD_REQUEST";
const AWARD_ERROR = "AWARD_ERROR";
const AWARDS_FETCH = "AWARDS_FETCH";
const AWARD_FETCH = "AWARD_FETCH";
const AWARD_CREATE = "AWARD_CREATE";
const AWARD_EDIT = "AWARD_EDIT";
const AWARD_DELETE = "AWARD_DELETE";

// Download Action Types for awards
const AWARD_DOWNLOAD_START = "AWARD_DOWNLOAD_START";
const AWARD_DOWNLOAD_UPDATE = "AWARD_DOWNLOAD_UPDATE";
const AWARD_DOWNLOAD_FINISH = "AWARD_DOWNLOAD_FINISH";

const BaseRoute = "cfwebapi/api/v1/awards";

// Reusable action types object for consistency
const actionTypes = {
  fetches: {
    request: AWARD_REQUEST,
    success: AWARDS_FETCH,
    error: AWARD_ERROR,
  },
  fetch: { request: AWARD_REQUEST, success: AWARD_FETCH, error: AWARD_ERROR },
  create: { request: AWARD_REQUEST, success: AWARD_CREATE, error: AWARD_ERROR },
  update: { request: AWARD_REQUEST, success: AWARD_EDIT, error: AWARD_ERROR },
  delete: { request: AWARD_REQUEST, success: AWARD_DELETE, error: AWARD_ERROR },
  download: {
    request: AWARD_REQUEST,
    start: AWARD_DOWNLOAD_START,
    update: AWARD_DOWNLOAD_UPDATE,
    finish: AWARD_DOWNLOAD_FINISH,
    success: AWARDS_FETCH,
    error: AWARD_ERROR,
  },
};

const INITIAL_STATE = {
  loading: false,
  success: false,
  awards: [],
  award: {},
  error: "",
  downloadProgress: 0,
  isDownloading: false,
};

// Actions using the new handlers

export const FetchAwards = () => async (dispatch) => {
  await createProgressiveRequestHandler(
    dispatch,
    () =>
      cfAPI.get(BaseRoute, {
        onDownloadProgress: createProgressHandler(
          dispatch,
          actionTypes.download.update,
          actionTypes.download.finish
        ),
      }),
    actionTypes.download,
    createProgressHandler
  );
};

export const FetchAward = (id) => async (dispatch) => {
  await createRequestHandler(
    dispatch,
    () => cfAPI.get(`${BaseRoute}/${id}`),
    actionTypes.fetch,
    null // No toast for a fetch
  );
};

export const CreateAward = (values) => async (dispatch) => {
  await createRequestHandler(
    dispatch,
    () => cfAPI.post(BaseRoute, createFormData),
    actionTypes.create,
    "Award Created"
  );
};

export const UpdateAward = (id, values) => async (dispatch) => {
  await createRequestHandler(
    dispatch,
    () => cfAPI.patch(`${BaseRoute}/${id}`, createFormData(values)),
    actionTypes.update,
    "Award Updated"
  );
};

export const DeleteAward = (id, values) => async (dispatch) => {
  await createRequestHandler(
    dispatch,
    () => cfAPI.delete(`${BaseRoute}/${id}`), // Fixed: used id instead of values.id
    actionTypes.delete,
    "Award Deleted"
  );
};

// Reducer with toasts removed and state logic updated
export const AwardsReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case AWARD_DOWNLOAD_START:
      return { ...state, isDownloading: true, downloadProgress: 0 };
    case AWARD_DOWNLOAD_UPDATE:
      return { ...state, downloadProgress: action.payload };
    case AWARD_DOWNLOAD_FINISH:
      return { ...state, isDownloading: false, downloadProgress: 100 };
    case AWARD_REQUEST:
      return { ...state, loading: true };
    case AWARDS_FETCH:
      return { ...state, loading: false, error: "", awards: action.payload };
    case AWARD_FETCH:
      return { ...state, loading: false, error: "", award: action.payload };
    case AWARD_CREATE:
      return {
        ...state,
        loading: false,
        error: "",
        success: true,
        awards: [...state.awards, action.payload],
      };
    case AWARD_EDIT:
      const updatedList = state.awards.map((award) =>
        award.id === action.payload.id ? action.payload : award
      );
      return {
        ...state,
        loading: false,
        error: "",
        success: true,
        award: action.payload,
        awards: updatedList,
      };
    case AWARD_DELETE:
      const newList = state.awards.filter((s) => s.id !== action.payload.id);
      return {
        ...state,
        loading: false,
        error: "",
        awards: newList,
      };
    case AWARD_ERROR:
      return { ...state, loading: false, error: action.payload };
    default:
      return state;
  }
};
